module.exports = __webpack_public_path__ + "static/media/potager.f480fabb.jpg";